<template>
  <d2-container>
    <div class="toolbar">
      <el-select
        v-model="currentCategoryId"
        placeholder="选择分类"
        clearable
        size="mini"
        style="width: 200px; margin-right: 8px;"
        @change="handleCategoryChange"
      >
        <el-option
          v-for="item in categoryOptions"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        size="mini"
        icon="el-icon-circle-plus"
        @click="openDialog()"
      >新增提示词</el-button>
    </div>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      :loading="listLoading"
      :data="templateList"
    >
      <el-table-column align="center" label="ID" prop="id" width="80" />
      <el-table-column align="center" label="分类" min-width="140">
        <template slot-scope="scope">
          {{ categoryMap[scope.row.categoryId] || '--' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="名称" prop="name" min-width="160" />
      <el-table-column align="center" label="排序" prop="sort" width="100" />
      <el-table-column label="内容" min-width="220" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top" width="400">
            <div class="content-preview">{{ scope.row.content }}</div>
            <span slot="reference">{{ renderShortContent(scope.row.content) }}</span>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间" prop="createTime" min-width="170" />
      <el-table-column align="center" label="更新时间" prop="updateTime" min-width="170" />
      <el-table-column align="center" label="操作" fixed="right" width="200">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="openDialog(scope.row)"
            style="margin-top: 6px;"
          >编辑</el-button>
          <el-button
            size="small"
            type="danger"
            @click="handleRemove(scope.row)"
            style="margin-top: 6px;"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="680px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="resetForm"
    >
      <el-form :model="form" :rules="rules" ref="formRef" label-width="90px">
        <el-form-item label="分类" prop="categoryId">
          <el-select
            v-model="form.categoryId"
            filterable
            placeholder="请选择分类"
            style="width: 100%;"
          >
            <el-option
              v-for="item in categoryOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入提示词名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="form.sort" :min="0" :step="1" step-strictly></el-input-number>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input
            type="textarea"
            :autosize="{ minRows: 6 }"
            v-model="form.content"
            placeholder="请输入提示词内容"
            maxlength="2000"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </d2-container>
</template>

<script>
import {
  addPromptTemplate,
  getPromptCategoryList,
  getPromptTemplateList,
  removePromptTemplate,
  updatePromptTemplate
} from '@/api/common/prompt'

export default {
  name: 'promptTemplate',
  data () {
    return {
      tableKey: 0,
      listLoading: false,
      templateList: [],
      categoryOptions: [],
      categoryMap: {},
      currentCategoryId: null,
      dialogVisible: false,
      dialogTitle: '新增提示词',
      form: {
        id: null,
        categoryId: '',
        name: '',
        sort: 0,
        content: ''
      },
      rules: {
        categoryId: [{ required: true, message: '请选择分类', trigger: 'change' }],
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
        ],
        sort: [{ type: 'number', message: '排序必须为数字', trigger: 'change' }],
        content: [{ required: true, message: '请输入内容', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.loadCategories()
  },
  methods: {
    loadCategories () {
      getPromptCategoryList().then(res => {
        this.categoryOptions = res || []
        this.categoryMap = (res || []).reduce((map, item) => {
          map[item.id] = item.name
          return map
        }, {})
        if (!this.currentCategoryId && this.categoryOptions.length) {
          this.currentCategoryId = this.categoryOptions[0].id
        }
        this.loadTemplates()
      })
    },
    loadTemplates () {
      if (!this.currentCategoryId) {
        this.templateList = []
        return
      }
      this.listLoading = true
      getPromptTemplateList(this.currentCategoryId)
        .then(res => {
          this.templateList = res || []
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    handleCategoryChange () {
      this.loadTemplates()
    },
    openDialog (row) {
      this.dialogTitle = row ? '编辑提示词' : '新增提示词'
      this.dialogVisible = true
      this.form = row
        ? {
          id: row.id,
          categoryId: row.categoryId,
          name: row.name,
          sort: row.sort,
          content: row.content
        }
        : {
          id: null,
          categoryId: this.currentCategoryId || '',
          name: '',
          sort: 0,
          content: ''
        }
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate()
        }
      })
    },
    submitForm () {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        const payload = {
          categoryId: this.form.categoryId,
          name: this.form.name,
          sort: this.form.sort,
          content: this.form.content
        }
        const request = this.form.id
          ? updatePromptTemplate(this.form.id, payload)
          : addPromptTemplate(payload)
        request.then(() => {
          this.$message({
            message: this.form.id ? '更新成功' : '新增成功',
            type: 'success',
            center: true
          })
          this.dialogVisible = false
          this.loadTemplates()
        })
      })
    },
    handleRemove (row) {
      this.$confirm('此操作将删除该提示词, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => removePromptTemplate(row.id))
        .then(() => {
          this.$message({
            message: '删除成功',
            type: 'success',
            center: true
          })
          this.loadTemplates()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    renderShortContent (content) {
      if (!content) return '--'
      return content.length > 60 ? `${content.slice(0, 60)}...` : content
    },
    resetForm () {
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields()
      }
      this.form = {
        id: null,
        categoryId: this.currentCategoryId || '',
        name: '',
        sort: 0,
        content: ''
      }
    }
  }
}
</script>

<style scoped>
.toolbar {
  margin-bottom: 12px;
}
.content-preview {
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
